module.exports = __webpack_public_path__ + "static/media/icomoon.cbbf2cf1.svg";